import { useTranslation } from 'react-i18next';

import parameterize from '~/utils/parameterize';

interface Props {
  utmSource: string;
  beehiivBranding?: boolean;
  color?: string;
}

const CopyrightFooter = ({ utmSource, beehiivBranding = false, color }: Props) => {
  const source = parameterize(utmSource, '_');
  const { t } = useTranslation();

  return (
    <div
      style={{ color: color }}
      className="wt-text-on-subscribe-background-color absolute bottom-2 left-1/2 z-10 -translate-x-1/2 transform text-center sm:bottom-4 sm:left-4 sm:translate-x-0"
    >
      <div className="flex flex-col sm:flex-row sm:space-x-4">
        {beehiivBranding && (
          <p className="whitespace-nowrap text-xs leading-tight sm:text-sm">
            <small>
              {`${t('footer.article')} `}
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={`https://beehiiv.com?utm_source=${source}&utm_medium=subscribe_page`}
                className="underline"
              >
                beehiiv
              </a>
              {` ${t('footer.newsletter')}`}
            </small>
          </p>
        )}
        <p className="whitespace-nowrap text-xs leading-tight sm:text-sm">
          <small>
            <a
              href={`https://beehiiv.com/privacy?utm_source=${source}&utm_medium=subscribe_page`}
              target="_blank"
              className="underline opacity-30"
              rel="noopener noreferrer"
            >
              {t('footer.privacy_policy')}
            </a>
          </small>
        </p>
        <p className="whitespace-nowrap text-xs leading-tight sm:text-sm">
          <small>
            <a
              href={`https://beehiiv.com/tou?utm_source=${source}&utm_medium=subscribe_page`}
              target="_blank"
              className="underline opacity-30"
              rel="noopener noreferrer"
            >
              {t('footer.terms_of_use')}
            </a>
          </small>
        </p>
      </div>
    </div>
  );
};

export default CopyrightFooter;
